import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=7f068830&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f068830"]])

export default __exports__